import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
    Box,
    Card,
    DataLegend,
    SkeletonItem,
    Text,
} from '@paygreen/paygreen-ui';
import { ErrorBoundary } from '../../../components';

const ContributionDetailCard = ({
    t,
    colorPallet,
    colorTheme,
    colorStatus,
    cardTitle,
    contributionData,
    isLoading,
    ...rest
}) => {
    const { convertedValue, convertedUnit } = contributionData;

    return (
        <ErrorBoundary>
            <SkeletonItem
                isLoading={isLoading}
                colorWab="grey10"
                radiusSize="sm"
                blockWidth="xl"
            >
                <Card
                    colorPallet={colorPallet}
                    colorTheme={colorTheme}
                    colorStatus={colorStatus}
                    shadowSize="none"
                    blockWidth="none"
                    paddingLateral="xs"
                    paddingBottom="xs"
                    paddingTop="xs"
                    radiusSize="sm"
                    {...rest}
                >
                    <Text colorWab="grey50" textSize="xs">
                        {cardTitle}
                    </Text>

                    <Box marginTop="md">
                        <DataLegend
                            textSize="sm"
                            value={convertedValue}
                            unit={t(`carbonUnits.${convertedUnit}`, {
                                count: convertedValue,
                            })}
                            colorPallet={colorPallet}
                            colorTheme={colorTheme}
                            colorStatus={colorStatus}
                        />
                    </Box>
                </Card>
            </SkeletonItem>
        </ErrorBoundary>
    );
};

ContributionDetailCard.propTypes = {
    colorPallet: PropTypes.string,
    colorStatus: PropTypes.string,
    colorTheme: PropTypes.string,
    cardTitle: PropTypes.string,
    contributionData: PropTypes.object,
    isLoading: PropTypes.bool,
};

ContributionDetailCard.defaultProps = {
    colorPallet: 'status',
    colorStatus: 'default',
    colorTheme: 'primary',
    isLoading: false,
};

export default withTranslation('common')(ContributionDetailCard);
